<template>
    <section class="post-tile">
        <a :href="postData.link" target="_blank" class="link" title="">
            <div class="image-wrapper" v-if="!isTextOnly">
                <img :src="postData.image" class="image" :alt="postData.title">
                <div class="hover-overlay"></div>
            </div>
            <div class="content-text">
                <div class="favicon" :class="postData.source"></div>
                <div class="text" :class="isTextOnly? 'no-img':'with-img'">
                    <div :class="isTextOnly? 'no-img':'with-img'" v-html="htmlReplace(postData.description)"></div>
                    <!--<i class="icon-gt"></i>--></div>
                <div class="footer">
                    <div class="left">{{postData.user_real_name}}</div>
                    <div class="right">{{getDate(postData.posted_at)}}</div>
                </div>
            </div>
        </a>
    </section>
</template>
<script>

import { format } from 'date-fns'

export default {

    props: [ 'postData', 'index' ],
    data() {
        return {

        }
    },
    computed: {
        isTextOnly() {
            return this.postData.image == null;
        }
    },
    methods: {
        getDate( dateString ) {
            return format(new Date(dateString), 'dd.MM.yyyy hh:mm')
        },
        htmlReplace( text ) {
            return text.replace( /(?:\r\n|\r|\n)/g, '<br />' ).replace( /#([a-zA-Z0-9_éÉàÀèÈùÙâÂêÊîÎôÔûÛëËïÏçÇäöüÄÜÖ]+)/g, '<span class="hashtag">#$1</span>' );
        }
    }
}
</script>
<style scoped>
</style>
